export const FIELD_TEXT = 'FIELDS_INPUT_TEXT';
export const FIELD_TEXTAREA = 'FIELDS_INPUT_TEXTAREA';
export const FIELD_TITLE = 'FIELDS_ELEMENT_TITLE';
export const FIELD_DESCRIPTION = 'FIELDS_ELEMENT_DESCRIPTION';
export const FIELDS_START_END_INPUTS = 'FIELDS_START_END_INPUTS';
export const FIELDS_INPUT_DECISION_RADIOGROUP = 'FIELDS_INPUT_DECISION_RADIOGROUP';
export const FIELDS_NOTE_INPUT_FIELD = 'FIELDS_NOTE_INPUT_FIELD';
